import { combineValidators, isRequired } from "revalidate";
import { adultPassengerNumberValidator } from "app/utils/form/fieldValidators";
import { babiesNumberMustNotExceedAdultsNumber } from "app/utils/form/validators";

export const flightAndHotelFields = [
	"offer",
	"departureCityCode",
	"departureDate",
	"duration",
	"adults",
	"children",
	"infants",
	"childrenBirthdates[].day",
	"childrenBirthdates[].month",
	"childrenBirthdates[].year",
	"infantsBirthdates[].day",
	"infantsBirthdates[].month",
	"infantsBirthdates[].year",
];

export const hotelOnlyFields = [
	"offer",
	"departureDate",
	"duration",
	"adults",
	"children",
	"infants",
	"childrenBirthdates[].day",
	"childrenBirthdates[].month",
	"childrenBirthdates[].year",
	"infantsBirthdates[].day",
	"infantsBirthdates[].month",
	"infantsBirthdates[].year",
];

export const validate = combineValidators({
	offer: isRequired({
		message: "TODO offer isRequired",
	}),
	duration: isRequired({
		message: "TODO duration isRequired",
	}),
	departureDate: isRequired({
		message: "TODO departureDate isRequired",
	}),
	adults: adultPassengerNumberValidator,
	infants: babiesNumberMustNotExceedAdultsNumber("adults")({
		message: { id: "error.search.engine.infants.exceed.adults" },
	}),
	"childrenBirthdates[]": {
		day: isRequired({
			message: { id: "error.birthdate.day" },
		}),
		month: isRequired({
			message: { id: "error.birthdate.month" },
		}),
		year: isRequired({
			message: { id: "error.birthdate.year" },
		}),
	},
	"infantsBirthdates[]": {
		day: isRequired({
			message: { id: "error.birthdate.day" },
		}),
		month: isRequired({
			message: { id: "error.birthdate.month" },
		}),
		year: isRequired({
			message: { id: "error.birthdate.year" },
		}),
	},
});
